export enum TranferType {
  TRANSFER_IN,
  TRANSFER_OUT,
}
